module.exports = __webpack_public_path__ + "static/media/409496.21a504b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStaff/409496.png
// module id = 1432
// module chunks = 0